<template>
  <div class="m-0 dbozone-font bg-centilliongod" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-centilliongod">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("centilliongod.paytable.symtable_title") }}
          </h5>
        </section>
      </div>
      <div class="d-flex flex-row mt-5">

        <div class="nav-wild-centilliongod d-flex">
          <img class="icon-paytable wild mt-2 ml-2" :class="`-wild`"
            :src="require(`../../assets/resultGame/centilliongod/symbol_0.png`)" alt="" />
          <p class="wild-text text-sub" :class="`-${lang}`">
            {{ $t("centilliongod.paytable.symtable_wild") }}
          </p>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row mt-4 ml-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/centilliongod/symbol_2.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{ "5 - " + paytable[2][4] }} <br />{{ "4 - " + paytable[2][3] }}
            <br />{{ "3 - " + paytable[2][2] }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/centilliongod/symbol_3.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{ "5 - " + paytable[3][4] }} <br />{{ "4 - " + paytable[3][3] }}
            <br />{{ "3 - " + paytable[3][2] }}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-4 ml-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/centilliongod/symbol_4.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{ "5 - " + paytable[4][4] }} <br />{{ "4 - " + paytable[4][3] }}
            <br />{{ "3 - " + paytable[4][2] }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/centilliongod/symbol_5.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{ "5 - " + paytable[5][4] }} <br />{{ "4 - " + paytable[5][3] }}
            <br />{{ "3 - " + paytable[5][2] }}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4 ml-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/centilliongod/symbol_6.png`)" alt="" />
        </div>
        s
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{ "5 - " + paytable[6][4] }} <br />{{ "4 - " + paytable[6][3] }}
            <br />{{ "3 - " + paytable[6][2] }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/centilliongod/symbol_7.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{ "5 - " + paytable[7][4] }} <br />{{ "4 - " + paytable[7][3] }}
            <br />{{ "3 - " + paytable[7][2] }}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-4 ml-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/centilliongod/symbol_8.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{ "5 - " + paytable[8][4] }} <br />{{ "4 - " + paytable[8][3] }}
            <br />{{ "3 - " + paytable[8][2] }}
          </span>
        </div>
      </div>


      <div class="d-flex flex-column nav-centilliongod mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("centilliongod.bonus.title") }}
          </h5>
        </section>
      </div>

      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/centilliongod/symbol_1.png`)" alt="" />
        </div>
      </div>
      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-sub" :class="`-${lang}`">
          {{ $t("centilliongod.bonus.text1") }} <br />
          {{ $t("centilliongod.bonus.text2") }}
        </p>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/centilliongod/bonus2.png`)" alt="" />
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row">
        <div class="d-flex p-2 mt-3 align-items-center">
          <p class="m-0 text-sub" :class="`-${lang}`">
            {{ $t("centilliongod.bonus.text3") }}
          </p>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/centilliongod/bonus3.png`)" alt="" />
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row">
        <div class="d-flex p-2 mt-3 align-items-center">
          <p class="m-0 text-sub" :class="`-${lang}`">
            {{ $t("centilliongod.bonus.text4") }}
          </p>
        </div>
      </div>

      <div class="d-flex flex-column nav-centilliongod mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("centilliongod.freespin.title") }}
          </h5>
        </section>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-sub" :class="`-${lang}`">
          {{ $t("centilliongod.freespin.text1") }} <br />
          {{ $t("centilliongod.freespin.text2") }}
        </p>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-freespin-centilliongod" :class="`-${lang}`">
          {{ $t("centilliongod.freespin.text3") }}
        </p>
      </div>
      <div>
        <hr class="hr-freespin-centilliongod" />
      </div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <div class="p-0 align-items d-flex">
          <img class="mt-3 icon-paytable-centilliongod"
            :src="require(`../../assets/paytable/centilliongod/freespin1.png`)" alt="" />
        </div>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-freespin-centilliongod" :class="`-${lang}`">
          {{ $t("centilliongod.freespin.text4") }}
        </p>
      </div>
      <div>
        <hr class="hr-freespin-centilliongod" />
      </div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <div class="p-0 align-items d-flex">
          <img class="mt-3 icon-paytable-centilliongod"
            :src="require(`../../assets/paytable/centilliongod/freespin2.png`)" alt="" />
        </div>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-freespin-centilliongod" :class="`-${lang}`">
          {{ $t("centilliongod.freespin.text5") }}
        </p>
      </div>
      <div>
        <hr class="hr-freespin-centilliongod" />
      </div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <div class="p-0 align-items d-flex">
          <img class="mt-3 icon-paytable-centilliongod"
            :src="require(`../../assets/paytable/centilliongod/freespin3.png`)" alt="" />
        </div>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-freespin-centilliongod" :class="`-${lang}`">
          {{ $t("centilliongod.freespin.text6") }}
        </p>
      </div>
      <div>
        <hr class="hr-freespin-centilliongod" />
      </div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <div class="p-0 align-items d-flex">
          <img class="mt-3 icon-paytable-centilliongod"
            :src="require(`../../assets/paytable/centilliongod/freespin4.png`)" alt="" />
        </div>
      </div>

      <div class="d-flex flex-column nav-centilliongod mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">{{ $t('bonusGameBuy.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 icon-startbutton"
          :src="require(`../../assets/paytable/centilliongod/feature_buy_${imgLang}.png`)" alt="">
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('bonusGameBuy.text1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('bonusGameBuy.text2') }}</span>
      </div>

      <div class="d-flex flex-column nav-centilliongod mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("centilliongod.line.title") }}
          </h5>
        </section>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-sub" :class="`-${lang}`">
          {{ $t("centilliongod.line.text1") }} <br />
          {{ $t("centilliongod.line.text2") }} <br />
          {{ $t("centilliongod.line.text3") }}
        </p>
      </div>
      <div class="justify-content-center d-flex flex-row">
        <img class="icon-paytable" :src="require(`../../assets/paytable/centilliongod/pay_line.png`)" alt="" />
      </div>

      <div class="d-flex flex-column nav-centilliongod mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("centilliongod.winbetline.title") }}
          </h5>
        </section>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-sub" :class="`-${lang}`">
          {{ $t("centilliongod.winbetline.text1") }} <br />
          {{ $t("centilliongod.winbetline.text2") }} <br />
          {{ $t("centilliongod.winbetline.text3") }}
        </p>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'paytable-centilliongod',
  props: {
    data: Object,
    lang: String,
    imgLang: String
  },
  data() {
    return {
      paytable: this.data.config.payTable,
    };
  },
};
</script>

<style>
/* .wild-positon {
  position: relative;
} */

.nav-centilliongod {
  background-color: #a11010;
  border-radius: 14px;
}

.icon-paytable {
  width: 100%;
}

.icon-paytable.-wild {
  position: absolute;
  width: 18%;
  /* height: 17.6vw; */
}

.icon-paytable-centilliongod {
  width: 65vw;
}

.bg-centilliongod {
  background: #391818;
}

.wild-text {
  justify-content: center;
  margin-left: 25vw;
  margin-top: 3vw;
}

@media screen and (max-width: 768px) {
  .bg-centilliongod {
    background: #000;
  }
}

.text-freespin-centilliongod {
  color: #ffe463;
  font-size: 4.5vw;
}

.nav-wild-centilliongod {
  border-radius: 14px 14px 14px 14px;
  border-left-style: solid;
  border-right-style: solid;
  border-top-style: solid;
  border-bottom-style: solid;
  border-color: #a11010;
  width: 100%;
  height: 24.5vw;
  /* margin-left: 17vw; */
}

.icon-paytable.-wild {
  margin-right: 100px;
}

.hr-freespin-centilliongod {
  border: 2px solid #ffe463;
  border-radius: 5px;
  margin-top: 0vw;
}

@media screen and (max-width: 768px) {
  .header>div {
    flex-grow: 0;
    width: 33.33%;
  }
}
</style>